import React from 'react';
import Navbar from './Navbar';
import Login from './Login';
import TradingBar from './Trading Bar/TradingBar';
import CoinsAPI from './CoinsAPI';
import Swiper from './Swiper/Swiper';
import Footer from './Footer';


function App() {
  
  
  
  return (
    <div>

      <header>
        <div className="header">
          <div className="logo">
            <i class="fa-solid fa-chart-simple"></i>
            <a  href="#">STX</a>
          </div>     
          <div className="nav-area">
            <Navbar />
            <Login />
          </div>
        </div>
      </header>

      <section>
        <div className="trading-bar">
          <i class="fas fa-bars"></i>
          <div className="trading-pairs">
            <TradingBar />
          </div>
        </div>
      </section>

      <section>
        <div className="swiperContainer">
          <Swiper />
        </div>
      </section>

      <section>
        <CoinsAPI />
      </section>

      <section>
        <Footer />
      </section>
      
    </div>
  )

}

export default App;